import { render } from "./VetsAvailabilityTable.vue?vue&type=template&id=18ae8561&scoped=true&ts=true"
import script from "./VetsAvailabilityTable.vue?vue&type=script&lang=ts"
export * from "./VetsAvailabilityTable.vue?vue&type=script&lang=ts"

import "./VetsAvailabilityTable.vue?vue&type=style&index=0&id=18ae8561&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ae8561"]])

export default __exports__